import "./SubscriptionPreferences.scss";

import React, { useEffect, useRef } from "react";
import { subscriptionPreferencesReducer } from "./subscriptionPreferencesReducer";
import { all } from "redux-saga/effects";
import { authSaga } from "../_features/auth/authSaga";
import { IState } from "../../../../common/state/IState";
import { TSubscriptionPreferencesScreensMap } from "./SubscriptionPreferencesModel";
import { UmSpFormsScreenComponent } from "../formsScreen/UmSpFormsScreenComponent";
import { UmSpStartUpScreenComponent } from "../startUpScreen/UmSpStartUpScreenComponent";
import { UmSpErrorScreenComponent } from "../errorScreen/UmSpErrorScreenComponent";
import { useSelector } from "react-redux";
import { loadConsentsSaga } from "../_features/loadConsents/loadConsentsSaga";
import { loadSchemeSaga } from "../_features/loadSchemes/loadSchemeSaga";
import { saveConsentsSaga } from "../_features/saveConsents/saveConsentsSaga";
import {
    HorizontalBarElement,
    PerfectScrollContext,
    usePerfectScroll,
} from "@ngd-web/ngd-perfect-scrollbar";
import { VerticalBarElement } from "@ngd-web/ngd-perfect-scrollbar/scr/verticalBar/VerticalBarElement";
import { loadDynamicContentSaga } from "../_features/loadDynamicContent/loadDynamicContentSaga";
import { ScreenLockerComponent } from "../_modules/screenLocker/ScreenLockerComponent";

export const SubscriptionPreferencesPage = {
    pathPrefix: "subscriptionPreferences",
    reducer: subscriptionPreferencesReducer,
    Component,
    saga: function* () {
        console.log("root");
        yield all([
            authSaga(),
            loadConsentsSaga(),
            loadSchemeSaga(),
            saveConsentsSaga(),
            loadDynamicContentSaga(),
        ]);
        console.log("\\root");
    },
};

const screens: TSubscriptionPreferencesScreensMap = {
    init: UmSpStartUpScreenComponent,
    error: UmSpErrorScreenComponent,
    forms: UmSpFormsScreenComponent,
};

const selector = (s: IState) =>
    s?.userManagement?.subscriptionPreferences?.screen ?? "init";

function Component({ root = null as HTMLElement }) {
    const Screen = screens[useSelector(selector)];

    const [customScrollContext] = usePerfectScroll(useRef(root));
    useEffect(() => {
        root.classList.add("full-screen");
    }, []);

    return (
        <PerfectScrollContext.Provider value={customScrollContext}>
            {Screen ? <Screen /> : null}

            <VerticalBarElement />
            <HorizontalBarElement />
            <ScreenLockerComponent />
        </PerfectScrollContext.Provider>
    );
}
